var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    fieldDisplay: true,
    [_vm.valueType]: true,
    [_vm.fieldPath]: true,
    'red--text': _vm.isMaxValue,
  }},[(_vm.valueType === 'boolean')?[(_vm.computedValue === true || _vm.computedValue === false)?_c('v-simple-checkbox',{attrs:{"disabled":""},model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=$$v},expression:"computedValue"}}):_vm._e()]:(_vm.valueType === 'date-time')?[_vm._v(" "+_vm._s(_vm._f("datetime")(_vm.computedValue))+" ")]:(_vm.valueType === 'date')?[_vm._v(" "+_vm._s(_vm._f("date")(_vm.computedValue))+" ")]:(_vm.valueType === 'url')?[_c('a',{attrs:{"href":_vm.computedValue,"target":"_blank"}},[_vm._v(_vm._s(_vm.computedValue))])]:[_vm._v(" "+_vm._s(_vm.computedValue)+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }